import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import CancelButton from '../../../../../components/buttons/CancelButton'
import PrimaryButton from '../../../../../components/buttons/PrimaryButton'
import { SUBSCRIBER_REJECT } from '../../constants'

const useStyles = makeStyles((theme) => ({}))

export default (props) => {
  const { approveOrReject } = props
  const styleClass = useStyles()

  return (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      className={styleClass.dialogWrapper}
      open={true}
    >
      <DialogTitle disableTypography={true} className={styleClass.titleSection}>
        Approve
      </DialogTitle>

      <DialogContent className={styleClass.contentSection}></DialogContent>

      <DialogActions className={styleClass.footerSection}>
        <CancelButton
          className={styleClass.actionBtn}
          onClick={() => {
            approveOrReject(SUBSCRIBER_REJECT, false)
          }}
        >
          <FormattedMessage id="action.cancel" />
        </CancelButton>

        <PrimaryButton
          className={styleClass.actionBtn}
          onClick={() => {
            approveOrReject(SUBSCRIBER_REJECT, false)
          }}
        >
          <FormattedMessage id="action.yes" />
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  )
}
